import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  CANVAS: '[data-fragment="HpPromo.canvas"]',
  OVERLAY: '[data-fragment="HpPromo.overlay"]',
  BLUR: '[data-fragment="HpPromo.blur"]',
  ERASER: '[data-fragment="HpPromo.eraser"]',
  HAND: '[data-fragment="HpPromo.hand"]',
  HAND_IMAGE: '[data-fragment="HpPromo.handImage"]',
};

class HpPromo extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      erasing: false,
      prevX: 0,
    };
    this.scaleToFill = this.scaleToFill.bind(this);
    this.erase = this.erase.bind(this);
    this.startErasing = this.startErasing.bind(this);
    this.stopErasing = this.stopErasing.bind(this);
    this.init = this.init.bind(this);
    this.setOffset = this.setOffset.bind(this);
    this.redraw = this.redraw.bind(this);
  }
  didMount() {
    this.canvas = this.element.querySelector(fragments.CANVAS);
    this.blur = this.element.querySelector(fragments.BLUR);
    this.overlay = this.element.querySelector(fragments.OVERLAY);
    this.eraser = this.element.querySelector(fragments.ERASER);
    this.hand = this.element.querySelector(fragments.HAND);
    this.handImage = this.element.querySelector(fragments.HAND_IMAGE);
    window.addEventListener('mousemove', this.erase);
    this.on('touchmove', fragments.HAND, this.erase);
    this.on('mousedown', fragments.HAND, this.startErasing);
    this.on('touchstart', fragments.HAND, this.startErasing);
    window.addEventListener('mouseup', this.stopErasing);
    window.addEventListener('touchend', this.stopErasing);
    window.addEventListener('resize', this.redraw);
    this.init();
  }
  willUnMount() {}
  init = () => {
    this.context = this.canvas.getContext('2d');
    this.canvas.width = this.element.offsetWidth;
    this.canvas.height = this.element.offsetHeight;
    this.overlayImage = new Image();
    this.blurredImage = new Image();
    this.blurredImage.onload = (e) => {
      this.scaleToFill(e.target);
      this.blurredImageTarget = e.target;
      this.overlayImage.onload = (e) => {
        this.scaleToFill(e.target);
        this.overlayImageTarget = e.target;
      };
      this.overlayImage.src = this.overlay.getAttribute('src');
    };
    this.blurredImage.src = this.blur.getAttribute('src');
    this.x = null;
    this.y = null;
    this.eraserWidth = this.hand.clientWidth;
    this.eraserHeight = this.hand.clientHeight;
    this.setOffset();
  };
  setOffset = () => {
    this.offset = -20;
    if (window.innerWidth > 767) {
      this.offset = -50;
    }
    if (window.innerWidth > 1199) {
      this.offset = -100;
    }
  };
  redraw = () => {
    this.canvas.width = this.element.offsetWidth;
    this.canvas.height = this.element.offsetHeight;
    this.scaleToFill(this.blurredImageTarget);
    this.scaleToFill(this.overlayImageTarget);
    this.eraserWidth = this.hand.clientWidth;
    this.eraserHeight = this.hand.clientHeight;
    this.setOffset();
  };
  scaleToFill = (image) => {
    const scale = Math.max(this.canvas.width / image.width, this.canvas.height / image.height);
    const x = (this.canvas.width / 2) - ((image.width / 2) * scale);
    const y = (this.canvas.height / 2) - ((image.height / 2) * scale);
    this.context.drawImage(image, x, y, image.width * scale, image.height * scale);
  };
  erase = (e) => {
    e.preventDefault();
    if (this.state.erasing) {
      let xMouse = null;
      let yMouse = null;
      if (e.type === 'touchmove') {
        xMouse = e.touches[0].pageX;
        yMouse = e.touches[0].pageY;
      } else if (e.type === 'mousemove') {
        xMouse = e.pageX;
        yMouse = e.pageY;
      }
      this.x = xMouse - this.startX;
      const y = yMouse - this.startY;
      if (y > this.offset) {
        this.y = y;
      }
      this.context.globalCompositeOperation = 'destination-out';
      this.context.drawImage(this.eraser, this.x, this.y, this.eraserWidth, this.eraserHeight);
      this.hand.style.left = `${this.x}px`;
      this.hand.style.top = `${this.y}px`;
      let rotateZ = (this.state.prevX - this.x) / 2;
      if (rotateZ < -5) {
        rotateZ = -5;
      }
      if (rotateZ > 5) {
        rotateZ = 5;
      }
      let rotateY = (this.state.prevX - this.x) / 1.3;
      if (rotateY < -7) {
        rotateY = -7;
      }
      if (rotateY > 7) {
        rotateY = 7;
      }
      this.handImage.style.transform = `rotateY(${rotateY}deg) rotateZ(${rotateZ}deg) translateZ(-1rem)`;
      this.setState({
        prevX: this.x,
      });
    }
  };
  startErasing = (e) => {
    this.setState({
      erasing: true,
    });
    if (e.type === 'touchstart') {
      this.startX = e.touches[0].pageX - this.hand.offsetLeft;
      this.startY = e.touches[0].pageY - this.hand.offsetTop;
    } else if (e.type === 'mousedown') {
      this.startX = e.pageX - this.hand.offsetLeft;
      this.startY = e.pageY - this.hand.offsetTop;
    }
  };
  stopErasing = () => {
    this.setState({
      erasing: false,
    });
    this.handImage.style.transform = 'rotateY(0deg) rotateZ(0deg) translateZ(-1rem)';
  };
  update() {
    const { keydown, erasedItself } = this.state;
    classNames(this.hand, {
      'hp-promo__hand--move': keydown,
      'hp-promo__hand--erased': erasedItself,
    });
  }
}

export default HpPromo;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/HpPromo.js